<template>
  <div class="Firmware-version">
    <pageTitle />
    <business-group ref="businessGroup" :tableConfig="{...tableConfig}" :formConfig="{...formConfig}">
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-select placeholder="请选择维护状态" v-decorator="['keyword']" style="width:150px">
            <a-select-option v-for="el in DeviceSelect" :value="el.id" :key="el.id">{{ el.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </template>
      <template slot="formRight">
        <a-button type="primary" @click="add">新增</a-button>
      </template>
      <template slot="maintenanceStatus" slot-scope="record">
        <!--        {{ getDeviceModelName(record.deviceModel) }}-->
        {{ record.maintenanceStatus ? "是" : "否" }}
      </template>
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="edit(record)">编辑</a-button>
        <a-button type="link" @click="del(record)">删除</a-button>
      </template>

    </business-group>
    <a-modal :visible="visible"
             destroyOnClose
             :title="title"
             @ok="submitForm('ruleForm')"
             @cancel="resetForm('ruleForm')"
             :maskClosable="false"
             width="780px"
             >
      <a-form-model ref="ruleForm"
                    class="Firmware-version_ruleForm"
                    :title="title"
                    :model="ruleForm"
                    :rules="rules"
                    :label-col="{ span: 7 }"
                    :wrapper-col="{ span: 14 }">
        <a-form-model-item label="APP类型" prop="osType">
          <a-select  v-model="ruleForm.osType" placeholder="请选择APP类型" :disabled="!isAddnew" @change="showOpsSystemType">
            <a-select-option v-for="el in osTypeArray" :key="el.label" :value="el.value" :title="el.label">
              {{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="APP升级类型" prop="sellitemmenu">
          <a-select  v-model="ruleForm.sellitemmenu" placeholder="请选择APP升级类型" >
            <a-select-option v-for="el in sellitemmenuArray" :key="el.label" :value="el.value">
              {{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="APP来源" prop="appSource">
          <a-select  v-model="ruleForm.appSource" placeholder="请选择APP来源" >
            <a-select-option v-for="el in appSourceArray" :key="el.label" :value="el.value">
              {{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="操作系统类型" prop="opsSystemType" v-show="this.isShowOpsSystemType">
          <a-select  v-model="ruleForm.opsSystemType" placeholder="请选择操作系统类型" >
            <a-select-option v-for="el in opsSystemArray" :key="el.label" :value="el.value">
              {{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="版本号" prop="versionCode">
          <a-input type="text" placeholder="请输入版本号" v-model="ruleForm.versionCode" :disabled="!isAddnew"/>
        </a-form-model-item>
        <a-form-model-item label="维护状态" prop="maintenanceStatus">
          <a-radio-group name="radioGroup" :default-value="true" v-model="ruleForm.maintenanceStatus">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="上传更新包" prop="downloadUrl">
          <a-upload name="avatar"
                    :before-upload="beforeUpload"
                    v-model="ruleForm.downloadUrl"
                    :remove="remove"
                    :file-list="files"
                    class="m-upload"
                    :disabled="!isAddnew">
            <a-icon v-if="files.length<=0" :type="upLoading ? 'loading' : 'plus'" />
          </a-upload>
        </a-form-model-item>
        <a-form-model-item label="更新说明" prop="updateLog">
          <!-- <a-textarea placeholder="请输入更新说明" :rows="4" :maxLength="10000" v-model="ruleForm.updateLog" /> -->
          <div>
            <a-button class="editable-add-btn" @click="handleAdd">
              Add
            </a-button>
            <a-table bordered :data-source="updateLogDataSource" :columns="updateLogDataColumn">
              <template slot="lang" slot-scope="text, record,index">
                <editable-select-cell :allowCustom="true" :value="record.lang" :options="langs" @change="onCellChange('lang', $event,index)" />
              </template>
              <template slot="describe" slot-scope="text,record,index">
                <editable-cell :text="text" :value="record.describe" @change="onCellChange('describe', $event,index)" />
              </template>
              <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                  v-if="updateLogDataSource.length"
                  title="Sure to delete?"
                  @confirm="() => onDelete(record.key)"
                >
                  <a href="javascript:;">Delete</a>
                </a-popconfirm>
              </template>
            </a-table>
          </div>
        </a-form-model-item>
        <a-form-model-item label="富文本详细说明(官网)" prop="updateDetailRichText">
          <edit-components
            v-if="visible"
            :content="ruleForm.updateDetailRichText"
            :html-change="onUpdateDetailRichTextChange"
            :uploadImg="uploadRichTextImg"
            :upload-path="richTextUploadPath"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import formTime from "@/components/business/Form/formTime";
import formSkeleton from "@/components/business/Form/formSkeleton";
import editableCell from "@/components/business/Form/editableCell";
import editableSelectCell from "@/components/business/Form/editableSelectCell";
import editComponents from "@/components/EditComponents";
import { deviceType } from "@/utils/pageMaps";
import { confirm, tips } from "@/utils/util";
import { deviceSelect } from "@/utils/api";
import moment from "moment";
import { multipartUpload } from "@/utils/Oss";
import SparkMD5 from "spark-md5";

export default {
  components: {
    pageTitle,
    businessGroup,
    formTime,
    formSkeleton,
    editableCell,
    editableSelectCell,
    editComponents
  },
  name: "systemUpdate",
  created() {

  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("不能为空"));
      } else {
        callback();
      }

    };
    return {
      deviceType,
      isAddnew:true,//是否为新增
      upLoading: false,
      files: [],
      DeviceSelect: [
        { id: 1, name: "是" },
        { id: 0, name: "否" }
      ], // 型号
      dateFormat: this.$root.$data.dateFormat,
      tableConfig: {
        url: "bluetoothlight/web/version/versions/app",
        columns: [
          {
            title: "APP来源",
            dataIndex: "appSource",
            key: "appSource",
            align: "center",
            customRender: (text, record) => this.getAppSourceLabel(record?.appSource || text)

          },
          {
            title: "APP升级类型",
            dataIndex: "sellitemmenu",
            key: "sellitemmenu",
            align: "center"

          },
          {
            title: "版本号",
            dataIndex: "versionCode",
            key: "versionCode",
            align: "center"

          },
          {
            title: "更新描述",
            dataIndex: "updateLog",
            key: "updateLog",
            align: "center"
          },
          {
            title: "时间",
            dataIndex: "updateTime",
            key: "updateTime",
            align: "center"

          },
          {
            title: "维护状态",
            dataIndex: "maintenanceStatus",
            key: "maintenanceStatus",
            align: "center",
            scopedSlots: { customRender: "maintenanceStatus" }
          },
          {
            title: "操作",
            align: "center",
            width: 150,
            scopedSlots: { customRender: "action" }
          }
        ],
        rowKey: "versionId"
      },
      formConfig: {
        timeShow: true,
        formShow: true
      },

      pageLoading: false,
      loading: false,
      visible: false,
      ruleForm: {
        // packageSize 默认为禁用 文件上传成功之后回显
      },
      osTypeArray: [
        {value: 'ANDROID', label: '安卓'},
        {value: 'ANDROIDIPAD', label: '安卓IPAD'},
        {value: 'IOS', label: '苹果'},
        {value: 'IOSIPAD', label: '苹果IPAD'},
        {value: 'WIN', label: 'WIN'},
        {value: 'MAC', label: '苹果MAC'},
      ],
      sellitemmenuArray: [
        {value: '强提示升级', label: '强提示升级'},
        {value: '简单提示升级', label: '简单提示升级'},
      ],
      appSourceArray: [
        {value: 'NEEWER', label: 'NEEWER'},
        {value: 'NEEWER TELEPROMPTER', label: 'NEEWER TELEPROMPTER'},
        {value: 'NEEWER Teleprompter for PC V2', label: 'NEEWER Teleprompter for PC'},
        //{value: 'NEEWER CONTROL CENTER', label: 'NEEWER CONTROL CENTER'},
        {value: 'NEEWER Mic for PC', label: 'NEEWER Mic for PC'},
        {value: 'NEEWER Control Center V2', label: 'NEEWER Control Center'},
        {value: 'NEEWER VIEW', label: 'NEEWER VIEW'},
        {value: 'NEEWER HOME', label: 'NEEWER HOME'},
        {value: 'NEEWER Pro', label: 'NEEWER Pro'},
        {value: 'NEEWER Audio', label: 'NEEWER Audio'},
        {value: 'NEEWER Flash', label: 'NEEWER Flash'},
      ],
      opsSystemArray: [
        {value: 'OPS_64', label: '64位'},
        {value: 'OPS_32', label: '32位'},
      ],
      rules: {
        maintenanceStatus: [{ required: true, validator: validatePass, trigger: "change" }],
        versionCode: [{ required: true, validator: validatePass, trigger: "change", message: "请输入版本号" }],
        // packageSize: [{ required: true, validator: validatePass, trigger: "change", message: "请上传更新包" }],
        marketDate: [{ required: true, validator: validatePass, trigger: "change", message: "请选择上市时间" }],
        osType: [{ required: true, validator: validatePass, trigger: "change", message: "请选择APP类型" }],
        sellitemmenu: [{ required: true, validator: validatePass, trigger: "change", message: "请选择APP升级类型" }],
        appSource: [{ required: true, validator: validatePass, trigger: "change", message: "请选择APP来源" }],
      },

      title: undefined,
      refresh: false,
      abort: undefined,
      isShowOpsSystemType: false,
      updateLogDataSource:[],
      updateLogDataColumn:[
          {
            title: '语言',
            dataIndex: 'lang',
            scopedSlots: { customRender: 'lang' },
          },
          {
            title: '说明',
            dataIndex: 'describe',
            scopedSlots: { customRender: 'describe' },
          },
          {
            title: '操作',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
          }
      ],
      langs:[{label:"中文",value:"CN"},{label:"英文",value:"EN"},{label:"日语",value:"JP"},{label:"意大利语",value:"IT"},{label:"西班牙语",value:"ES"},{label:"荷兰语",value:"NL"},{label:"德语",value:"DE"},{label:"法语",value:"FR"},{label:"波兰语",value:"PL"},{label:"瑞典语",value:"SV"}],
      richTextUploadPath: "bluetooth_light/systemUpdate_richtext"
    };
  },
  methods: {
    moment,
    getAppSourceLabel(appSource) {
      const value = appSource?.appSource || appSource?.record?.appSource || appSource?.text || appSource;
      const source = `${value || ""}`.toLowerCase();
      return this.appSourceArray.find((item) => `${item.value}`.toLowerCase() === source)?.label || value;
    },
    // 编辑  deviceModel 转了 number
    add() {
      this.isAddnew = true;
      this.title = "新增app";
      this.ruleForm = {
        maintenanceStatus: true,
        updateDetailRichText: ""
      };
      this.visible = true;

    },
    edit(record) {
      this.isAddnew = false;
      const { ruleForm, dateFormat } = this;
      const marketDate = moment(record.marketDate, dateFormat); // 处理时间
      const { deviceModel,updateLog } = record;
      // 回显更新包链接
      this.files = [{
        uid: "-1",
        name: record?.appName || record?.versionCode || "更新包" || record?.appSource || record?.sellitemmenu,
        status: "done",
        url: record?.downloadUrl?.toString()
      }];
      this.ruleForm = {
        ...ruleForm,
        ...record,
        marketDate,
        deviceModel: +deviceModel,
        updateDetailRichText: record.updateDetailRichText ?? record.update_detail_rich_text ?? ""
      };
      this.title = '编辑'
      this.visible = true;
      this.updateLogDataSource = this.parseMultiLang(updateLog);
      this.showOpsSystemType(this.ruleForm.osType);
    },
    // 删除  关键词  rowKey
    del(record) {
      const versionId = record?.versionId;
      if (!versionId || this.pageLoading) return false;

      this.pageLoading = true;

      const payload = {
        okBack: async () => {
          const res = await this.$http("DELETE", `/bluetoothlight/web/version/versions/app/${versionId}`);
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.refreshData();
          }
        },
        title: `是否删除该版本`
      };
      confirm(this, payload);
      this.pageLoading = false;

    },
    // 验证表单和提交数据
    submitForm(formName) {
      if (!formName) return false;
      this.$refs[formName].validate(async valid => {
        if (!valid) return false;
        //const { downloadUrl } = this.ruleForm;
        // if (!downloadUrl) {
        //   tips(this, false, "请上传文件");
        //   return false;
        // }
        this.ruleForm.updateLog = this.revertToOriginalText();
        const res = await this.$post(`/bluetoothlight/web/version/versions/app/${this.ruleForm.versionId || 0}`, this.ruleForm);
        const resultStatus = res?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.visible = false;
          this.refreshData();
          this.resetForm("ruleForm");
        }
        // 提示
        // 请求数据
      });
    },
    revertToOriginalText(){
        let parsedData = this.updateLogDataSource;
        // 处理空数组情况
        if (!Array.isArray(parsedData) || parsedData.length === 0) {
          return '';
        }

        // 转换每个语言块
        const blocks = parsedData.map(item => {
          // 处理特殊字符转义（如包含[]的情况）
          const escapedContent = item.describe.replace(/[$$$$]/g, '\\$&');
          return `[${item.lang}]${escapedContent}[/${item.lang}]`;
        });
        // 合并所有块并用空格分隔
        return blocks.join(' ');
    },
    parseMultiLang(text){
      const languageSections = text.match(/\[([A-Z]{2})\]([\s\S]*?)\[\/\1\]/g);
      const result = languageSections ? languageSections.map((section) => {
          const match = section.match(/\[([A-Z]{2})\]([\s\S]*?)\[\/\1\]/);
          const lang = match[1];
          const describe = match[2].trim();
          return {
              key: lang,
              lang: lang,
              describe: describe
          };
      }) : [];

      // 处理未匹配到任何语言块的情况
      if (!result || result.length === 0) {
        const defaultBlock = text.replace(/[\r]+/g, ' ').trim();
        result.push({
          key: "EN",
          lang: "EN",
          describe: defaultBlock
        });
      }
      return result;
    },
    // 重置表单和隐藏 modal
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.visible = false;
      this.ruleForm = {};
      if (this.upLoading) {
        this.upLoading = false;
        this.abort && this.abort();
      }
      this.updateLogDataSource = []
      this.files = [];
    },
    // 刷新table数据
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },
    // 获取设备型号
    getDeviceSelect: async function() {
      const res = await deviceSelect();
      this.DeviceSelect = res?.resultData || [];
    },

    /**
     *  根据id 获取对应的 name, 返回结果 String
     *  @param {String || Number} val
     *  val  === String 时 需要转 Number
     * */
    getDeviceModelName(val) {
      if (val === "" || val === undefined || val === null) return "";
      const { DeviceSelect } = this;
      if (!DeviceSelect || !DeviceSelect.length) return "";
      return DeviceSelect?.find(el => el.id === +val)?.name || "";
    },

    cancel(cancel) {
      this.abort = cancel;
    },
    UploadClient: async function(file) {
      this.fileName =  file?.name || file?.uid; // 先去版本号 再取文件的name
      this.upLoading = true;
      let uploadName = this.fileName;
      const res = await multipartUpload("systemUpdate/" + uploadName, file, this.cancel);
      const resultStatus = res?.resultStatus;
      if (!resultStatus) {
        this.upLoading = false;
        tips(this, resultStatus, res.name === "cancel" ? '上传已取消':'上传失败')
        return false;
      }

      if (!this.visible) return false; // 上传开始之后, 关闭了弹窗则阻止数据更新。应该是 取消 client的上传
      this.files = [{ ...res, uid: file?.uid }];

       // 计算md5
      const sliceLength = 10;
      const chunkSize = Math.ceil(file.size / sliceLength);
      const fileReader = new FileReader();
      const md5 = new SparkMD5();
      let index = 0;
      const loadFile = () => {
        const slice = file.slice(index, index + chunkSize);
        fileReader.readAsBinaryString(slice);
      };
      loadFile();
      fileReader.onload = (e) => {
        md5.appendBinary(e.target.result);
        if (index < file.size) {
          index += chunkSize;
          loadFile();
        } else {
          this.ruleForm.appPackageEncrypt = md5.end();
        }
      };

      this.ruleForm.downloadUrl = res?.url;
      this.ruleForm.packageSize = file?.size;
      this.ruleForm.appName = this.fileName;
      this.upLoading = false;
    },
    /**
     *  文件上传处理 返回结果时 false, 结束upload的事件
     *  @param {File} file
     *  fileName 获取文件的 name或者id
     *  client 上传到oss 返回  {url,name}
     * */
    beforeUpload(file) {

      this.UploadClient(file);

      return false;
    },
    remove() {
      this.ruleForm.downloadUrl = undefined;
      this.ruleForm.packageSize = undefined;
      this.files = [];
    },
    showOpsSystemType(e){
        let osTypeVal = e;
        if(osTypeVal == 'WIN'){
          this.isShowOpsSystemType = true;
        }else{
          this.isShowOpsSystemType = false;
        }
    },
    onCellChange(dataIndex,value,index) {
      const dataSource = [...this.updateLogDataSource];
      console.log(dataSource);
      console.log(index);
      const target = dataSource[index];
      console.log(target);
      if (target) {
        target[dataIndex] = value;
        if(dataIndex == "lang"){
          target["key"] = value;
        }
        console.log(dataSource);
        this.updateLogDataSource = dataSource;
      }
    },
    onDelete(key) {
      const dataSource = [...this.updateLogDataSource];
      this.updateLogDataSource = dataSource.filter(item => item.key !== key);
    },
    handleAdd() {
      const { updateLogDataSource } = this;
      for(const lang of this.langs){
        let item = this.updateLogDataSource.find(log => log.lang == lang.value);
        console.log(item);
        if(!item){
          console.log(item);
          const newData = {
            lang: lang.value,
            describe: "",
            key: lang.value
          };
          this.updateLogDataSource = [...updateLogDataSource, newData];
          return;
        }
      }
    },
    onUpdateDetailRichTextChange(html) {
      this.ruleForm.updateDetailRichText = html;
    },
    uploadRichTextImg: async function (file, callback, contextPath) {
      const res = await multipartUpload(file?.name, file, null, contextPath || "bluetooth_light");
      const resultStatus = res?.resultStatus;
      if (!resultStatus) {
        tips(this, resultStatus, res.name === "cancel" ? "上传已取消" : "上传失败");
        return false;
      }
      callback && callback?.(res?.url);
    }
  }
};
</script>

<style lang="less" scoped>

.Firmware-version_ruleForm {
  width: 780px;
  margin: 0 auto;

  .ant-form-item-children, .ant-calendar-picker {
    width: 100%;
  }
}
.m-upload {
  .ant-upload-select {
    width: 60px;
    height: 60px;
    border: 1px solid #C3C3C3;
    text-align: center;
    line-height: 60px;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
}


</style>
